import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonImg,
  IonItem,
  IonLabel,
  IonModal,
  IonRadio,
  IonRadioGroup,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import * as constants from "../constants";

interface PreviewModalProps {
  showPreview: boolean;
  setShowPreview: Function;
  document: string;
}

export const PreviewModal: React.FC<PreviewModalProps> = ({
  showPreview,
  setShowPreview,
  document,
}) => {
  return (
    <IonModal
      isOpen={showPreview}
      onDidDismiss={() => {
        setShowPreview(false);
      }}
      cssClass="preview-modal"
      backdropDismiss={true}
    >
      <div className="modal_body model_container">
        <div className="modal_panel customize_panel model_header web-header">
          <IonLabel className="modal_header vehicle_header">
            {/* {constants.CUSTOMIZE_YOUR_SERVICE} */}
          </IonLabel>
          <img
            onClick={() => setShowPreview(false)}
            src="/images/close_popup.svg"
            className="close_icon"
          />
        </div>
        <iframe
          src={document + "#toolbar=0"}
          style={{
            width: "100%",
            height: "85%",
          }}
        />
      </div>
    </IonModal>
  );
};
export default PreviewModal;
